import type {
  DocumentsApiGetDocumentsRequest as GetDocumentsParams,
  FullUpdateDto as CreateDocumentParams,
  DocumentsOutput,
  DocumentModel,
} from '@b-stock/location-api-client'

import appConfig from '@config/config'
import { flattenAPIParams } from '@helpers/listifyAPIParam'
import { post, get, deleteReq } from '@helpers/xhr'

const url = appConfig.api.locations.document

export default {
  get: (id: string) => get<DocumentModel>(url, { id }),
  create: (data: CreateDocumentParams) => post<DocumentModel>(url, data),
  deleteByDocId: (id: string) => deleteReq(`${url}/${id}`),
  getDocuments: async (params: GetDocumentsParams) => {
    const { data } = await get<DocumentsOutput>(url, flattenAPIParams(params))
    return data
  },
}
